/**
 * Effect - A side effect that runs when dependencies change
 *
 * @module @smoothie-framework/ui/state
 */
import { getCurrentObserver, setCurrentObserver } from './context';
import { beginTracking, cleanupObserver, createObserver, endTracking } from './graph';
import { createOwner, disposeOwner, getOwner, onCleanup, resetOwner, runWithOwner } from './scope';
export function effect(fn) {
    let disposed = false;
    const observer = createObserver(() => {
        if (!disposed) {
            run();
        }
    });
    observer.flushContext = getOwner()?.flushContext ?? observer.flushContext;
    const owner = createOwner(undefined, () => {
        disposed = true;
        cleanupObserver(observer);
    });
    const run = () => {
        if (disposed) {
            return;
        }
        cleanupObserver(observer);
        resetOwner(owner);
        const prevObserver = getCurrentObserver();
        beginTracking(observer);
        setCurrentObserver(observer);
        try {
            runWithOwner(owner, () => {
                const result = fn();
                if (typeof result === 'function') {
                    onCleanup(result);
                }
            });
        }
        finally {
            setCurrentObserver(prevObserver);
            endTracking(observer);
        }
    };
    run();
    return {
        dispose: () => {
            if (disposed) {
                return;
            }
            disposed = true;
            disposeOwner(owner);
        },
    };
}
//# sourceMappingURL=effect.js.map